// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-style[data-v-84c47c74] {\n  background: #EAEEF5;\n  border: 1px dashed #D5D5D5;\n  box-sizing: border-box;\n  border-radius: 2px;\n}\n.font-style[data-v-84c47c74] {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  color: #A2AAB8;\n}\n", ""]);
// Exports
module.exports = exports;
